import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../services/config.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class FaqService {

	defaultTemplate: string = "~/../app/load/faqs.json";
	customTemplate: string | undefined;

	constructor(
		private configService: ConfigService,
		private http: HttpClient
	) { }

	private getCustomFaqTemplate(groupName?: string): void {
		if (groupName) {
			// Checks the configuration for a custom template that matches the group
			let faqCustomTemplates = this.configService.getConfig().ui?.customPages?.faq || [];
			let custom = faqCustomTemplates.find((templateItem: any) => {
				return templateItem.group === groupName
			});

			this.customTemplate = custom ? custom.template : undefined;
		} else {
			this.customTemplate = undefined;
		}
	}

	// Custom FAQs are assumed to be HTML
	async getCustomFaq(groupName?: string): Promise<any> {
		this.getCustomFaqTemplate(groupName);

		if (this.customTemplate) {
			let url = this.customTemplate;

			try {
				const response = await firstValueFrom(this.http.get(url, { responseType: 'text' }));

				if (response) {
					return response;
				} else {
					return Promise.reject(false);
				}
			} catch (error) {
				console.error("Failed to get custom FAQ", error);
				return Promise.reject(error);
			}
		} else {
			return Promise.reject("No custom template defined");
		}
	}

	// The default FAQ is JSON
	async getDefaultFaq(): Promise<any> {
		let url = this.defaultTemplate;

		try {
			const response = await firstValueFrom(this.http.get<any>(url));

			if (response) {
				return response;
			} else {
				return Promise.reject(false);
			}
		} catch (error) {
			return Promise.reject(error);
		}
	}
}
